import * as React from 'react';
import Avatar from '@material-ui/core/Avatar';
import { Card, CardHeader, CardContent, IconButton, withStyles } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
// import FormControlLabel from '@material-ui/core/FormControlLabel';
// import Checkbox from '@material-ui/core/Checkbox';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Files from 'react-files';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import DeleteIcon from '@material-ui/icons/Delete';
import { SupportRequestTypes } from 'src/reducers/supportRequest';

export interface SupportPageViewProps {
    saveQueryType: (querytype: string) => void;
    saveMessages: (message: string) => void;
    saveAttachment: (attachment: string) => void;
    onSubmit: () => void;
    onFilesChange: (messageFiles: Array<File>) => void;
    onFilesError: (error: Error, images: Array<File>) => void;
    queryType: string;
    message: string;
    ticketGen: string;
    saveOrderNo: (orderno: string) => void;
    orderNo: string;
    messageFiles: Array<File>;
    orderDisabled: boolean;
    supportRequestTypes: SupportRequestTypes[];
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
            // height: 'calc(90vh - 64px)'
        },
        paper: {
            marginTop: '100px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
        },
        avatar: {
            margin: theme.spacing(1),
            backgroundColor: theme.palette.secondary.main,
        },
        card: {
            width: '100%'
        },
        cardHeader: {
            alignItems: 'center'
        },
        form: {
            width: '100%', // Fix IE 11 issue.
        },
        forms: {
            width: '100%', // Fix IE 11 issue.
        },
        textarea: {
            width: '100%'
        },
        filesDropzoneActive: {
            border: '3px solid #3f51b5',
            color: '#3f51b5',
        },
        fileUpload: {
            // margin: theme.spacing(1),
            textAlign: 'center',
            // fontSize: '10px',
            // borderRadius: '30%',
            // color: '#808080',
            height: '5.5vh',
            border: '2px solid #808080',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            // borderStyle: 'dotted',
            transition: 'all 1s',
            margin: theme.spacing(1, 0, 0),
            '&:hover': {
                color: '#3f51b5',
                border: '2px solid #3f51b5'
            },
        },
        submit: {
            margin: theme.spacing(1, 0, 0)
        },
        title: {
            fontSize: 14,
        },
        colorDel: {
            color: 'red',
            cursor: 'pointer'
        }
    })
);

const CssTextField = withStyles({
    root: {
        '& .MuiInputBase-root.Mui-disabled': {
            color: '#000',
        },
    },
})(TextField);

const SupportPageView: React.StatelessComponent<SupportPageViewProps> = props => {
    const classes = useStyles({});
    const inputLab = React.useRef<HTMLLabelElement>(null);
    const [lab, setLab] = React.useState(0);
    React.useEffect(() => {
        setLab(inputLab.current!.offsetWidth);
    });

    const deleteMsgAttach = () => {
        props.onFilesChange([]);
    };

    const disableSubmit = () => {
        if (props.message === '' || props.queryType === '') {
            return true;
        }
        return false;
    };

    return (
        <div className={classes.root}>
            <Container component="main" maxWidth="sm">
                <CssBaseline />
                <div className={classes.paper}>
                    <Card className={classes.card}>
                        <CardHeader
                            avatar={
                                <Avatar aria-label="recipe" className={classes.avatar}>
                                    <LockOutlinedIcon />
                                </Avatar>}
                            title={<h2>Support Request</h2>}
                            action={
                                <Typography className={classes.title} color="textSecondary" gutterBottom>
                                    Ticket No : {props.ticketGen}
                                </Typography>}
                        />
                        <CardContent>
                            <form className={classes.form} noValidate>
                                <Grid container spacing={2}>
                                    {/* <Grid item xs={12}>
                                        <TextField
                                            size="small"
                                            fullWidth
                                            label="Ticket No"

                                            disabled
                                            value={props.ticketGen}
                                        />
                                    </Grid> */}
                                    <Grid item xs={12}>
                                        <FormControl size="small" variant="outlined" className={classes.forms}>
                                            <InputLabel ref={inputLab} htmlFor="outlined-age-native-simple">
                                                How Can I Help You
                                            </InputLabel>
                                            <Select
                                                native
                                                onChange={event => props.saveQueryType(event.target.value as string)}
                                                labelWidth={lab}
                                                inputProps={{
                                                    name: 'lab',
                                                    id: 'outlined-age-native-simple',
                                                }}
                                                defaultValue="1"
                                                value={props.queryType}
                                            >
                                                <option disabled value="" />
                                                {/* <option value="0">General</option> */}
                                                {
                                                    Array.isArray(props.supportRequestTypes) && props.supportRequestTypes.length > 0 && props.supportRequestTypes.map((item) => (
                                                        <option value={item?.mt_code}>{item?.mt_name}</option>
                                                    ))
                                                }
                                                {/* <option value="bbb">bbb</option> */}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    {
                                        props.orderDisabled === true ?
                                            <Grid item xs={12} >
                                                <CssTextField
                                                    size="small"
                                                    variant="outlined"
                                                    fullWidth
                                                    label="Order No"
                                                    required
                                                    disabled
                                                    value={props.orderNo}
                                                />
                                            </Grid>
                                            :
                                            <Grid item xs={12} >
                                                <TextField
                                                    size="small"
                                                    variant="outlined"
                                                    fullWidth
                                                    label={'Order No'}
                                                    onChange={event => props.saveOrderNo(event.target.value)}
                                                    value={props.orderNo}
                                                />
                                            </Grid>
                                    }
                                    <Grid item xs={12}>
                                        <TextField
                                            variant="outlined"
                                            multiline
                                            rows={4}
                                            rowsMax={5}
                                            placeholder="Remarks..."
                                            onChange={event => props.saveMessages(event.target.value)}
                                            value={props.message}
                                            className={classes.textarea}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container spacing={2}>
                                    <Grid item xs={8}>
                                        <Button
                                            type="button"
                                            fullWidth
                                            variant="contained"
                                            color="primary"
                                            className={classes.submit}
                                            onClick={props.onSubmit}
                                            disabled={disableSubmit()}
                                        >
                                            Submit
                                        </Button>
                                    </Grid>
                                    <Grid item xs>
                                        <Files
                                            className={classes.fileUpload}
                                            onChange={props.onFilesChange}
                                            onError={props.onFilesError}
                                            accepts={['image/*']}
                                            multiple={false}
                                            maxFiles={1}
                                            maxFileSize={100000000}
                                            minFileSize={0}
                                            dropActiveClassName={classes.filesDropzoneActive}
                                            clickable
                                        >
                                            <AttachFileIcon />
                                        </Files>
                                    </Grid>
                                </Grid>
                                <Grid container spacing={1} justify="center" alignItems="center">
                                    {
                                        props.messageFiles.length > 0 &&
                                        <div>
                                            Attachment - <strong>{props.messageFiles[props.messageFiles.length - 1].name}</strong>&nbsp;
                                            <IconButton aria-label="delete" onClick={deleteMsgAttach}>
                                                <DeleteIcon className={classes.colorDel} fontSize="large" />
                                            </IconButton>
                                        </div>
                                    }
                                </Grid>
                            </form>
                        </CardContent>
                    </Card>
                </div>
            </Container>
        </div>
    );
};

export default SupportPageView;



// WEBPACK FOOTER //
// ./src/components/layouts/SupportView.tsx